export function toggleTableSortConfig(prev, key) {
  if (prev?.key === key) {
    return { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
  }
  return { key, direction: 'asc' };
}

export function getTableSortIcon(sortConfig, key) {
  if (sortConfig?.key !== key) return '↕';
  return sortConfig.direction === 'asc' ? '▲' : '▼';
}

export function stableSortTableRows(rows, sortConfig, compareByKey) {
  const key = sortConfig?.key;
  if (!key || !Array.isArray(rows)) return rows;
  const direction = sortConfig.direction === 'desc' ? 'desc' : 'asc';
  const items = rows.map((r, idx) => ({ r, idx }));
  items.sort((x, y) => {
    const result = compareByKey(x.r, y.r, key);
    if (result !== 0) return direction === 'asc' ? result : -result;
    return x.idx - y.idx;
  });
  return items.map((it) => it.r);
}

export function compareLocaleStrings(a, b) {
  return String(a ?? '').localeCompare(String(b ?? ''), undefined, { sensitivity: 'base' });
}

export function compareNumbers(a, b) {
  return (Number(a) || 0) - (Number(b) || 0);
}

export function compareDates(a, b) {
  return (Date.parse(String(a ?? '')) || 0) - (Date.parse(String(b ?? '')) || 0);
}
